import LargeNameTag from "./LargeNameTag";
export default LargeNameTag
